import React from "react";

const SLUGS = ["calcolatore-prezzi", "rimborsi-chilometrici"];

/** Invito al check-up fiscale gratuito: solo sugli strumenti per le imprese. */
export const CheckupInviteBox = ({ slug, utmMedium = "pagina_grazie" }) => {
  if (!SLUGS.includes(slug)) return null;
  const href = `https://casalisilvia.com/check-up-fiscale?utm_source=email&utm_medium=${utmMedium}&utm_campaign=${slug}`;

  return (
    <div
      className="bg-[#FAF6EE] border-2 border-[#C5A059] rounded-lg p-5 sm:p-6 text-left mb-8"
      data-testid="checkup-invite-box"
    >
      <p className="font-heading text-base md:text-lg text-[#0D1527] leading-snug mb-3">
        Quante tasse potresti risparmiare?
      </p>
      <p className="text-[#4A5568] text-sm sm:text-base leading-relaxed mb-5">
        Con il check-up fiscale gratuito rispondi a qualche domanda sulla tua attività e vedi subito
        quali strumenti previsti dalla legge puoi usare per pagare meno tasse, con una stima in euro.
      </p>
      <a
        href={href}
        className="inline-flex items-center justify-center bg-[#C5A059] text-white hover:bg-[#B38E46] px-6 sm:px-8 py-3 rounded font-bold tracking-wide transition-all w-full sm:w-auto"
        data-testid="checkup-invite-btn"
      >
        FAI IL CHECK-UP GRATUITO
      </a>
    </div>
  );
};
